// src/pages/Login.jsx
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";

export default function Login() {
  const [email,    setEmail]    = useState("");
  const [password, setPassword] = useState("");
  const [loading,  setLoading]  = useState(false);
  const [error,    setError]    = useState("");
  const { login } = useAuth();
  const navigate  = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await login(email, password);
      navigate("/");
    } catch {
      setError("Email o contraseña incorrectos");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: "100vh",
      background: "linear-gradient(135deg, #0f172a 0%, #1E3A5F 50%, #3A3C7A 100%)",
      display: "flex", alignItems: "center", justifyContent: "center",
      padding: 16, position: "relative", overflow: "hidden",
    }}>
      {/* Decoración de fondo — círculos difuminados */}
      <div style={{ position: "absolute", width: 400, height: 400, borderRadius: "50%", background: "rgba(124,58,237,0.12)", top: -100, right: -80, pointerEvents: "none" }} />
      <div style={{ position: "absolute", width: 300, height: 300, borderRadius: "50%", background: "rgba(29,158,117,0.08)", bottom: -80, left: -60, pointerEvents: "none" }} />

      <div style={{
        background: "rgba(255,255,255,0.97)",
        backdropFilter: "blur(12px)",
        borderRadius: 20,
        padding: "44px 40px",
        width: "100%", maxWidth: 420,
        boxShadow: "0 24px 60px rgba(0,0,0,0.30), 0 0 0 1px rgba(255,255,255,0.08)",
        position: "relative",
      }}>

        {/* Logo + nombre */}
        <div style={{ display: "flex", alignItems: "center", gap: 14, marginBottom: 32, justifyContent: "center" }}>
          <img src="/logo.png" alt="PROVEXO+" style={{ height: 52, width: "auto", objectFit: "contain" }} />
          <div>
            <div style={{ fontSize: 19, fontWeight: 800, color: "#1E3A5F", letterSpacing: "-0.03em" }}>
              CRM PROVEXO+
            </div>
            <div style={{ fontSize: 11, color: "#64748b", marginTop: 1 }}>
              Distribuidora B2B · Materiales de construcción
            </div>
          </div>
        </div>

        {/* Título */}
        <div style={{ marginBottom: 26 }}>
          <h2 style={{ fontSize: 23, fontWeight: 800, color: "#1e293b", margin: 0, letterSpacing: "-0.03em" }}>
            Bienvenido de vuelta
          </h2>
          <p style={{ fontSize: 13, color: "#64748b", marginTop: 5, lineHeight: 1.5 }}>
            Ingresa tus credenciales para acceder al sistema
          </p>
        </div>

        {/* Error */}
        {error && (
          <div style={{
            background: "#FEF2F2", color: "#DC2626",
            border: "1px solid #FECACA",
            padding: "10px 14px", borderRadius: 10,
            fontSize: 13, marginBottom: 18,
            display: "flex", alignItems: "center", gap: 8,
          }}>
            <span style={{ fontSize: 15 }}>⚠️</span>
            {error}
          </div>
        )}

        {/* Formulario */}
        <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: 18 }}>
          <div>
            <label style={{ display: "block", fontSize: 12, fontWeight: 600, color: "#374151", marginBottom: 7 }}>
              Email
            </label>
            <input
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
              placeholder="tu@email.com"
              style={{
                width: "100%", padding: "12px 14px",
                border: "1.5px solid #e5e7eb", borderRadius: 10,
                fontSize: 14, color: "#1e293b", outline: "none",
                background: "#fff", boxSizing: "border-box",
                fontFamily: "inherit",
                transition: "border-color 150ms cubic-bezier(0.23,1,0.32,1), box-shadow 150ms cubic-bezier(0.23,1,0.32,1)",
              }}
            />
          </div>

          <div>
            <label style={{ display: "block", fontSize: 12, fontWeight: 600, color: "#374151", marginBottom: 7 }}>
              Contraseña
            </label>
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
              placeholder="••••••••"
              style={{
                width: "100%", padding: "12px 14px",
                border: "1.5px solid #e5e7eb", borderRadius: 10,
                fontSize: 14, color: "#1e293b", outline: "none",
                background: "#fff", boxSizing: "border-box",
                fontFamily: "inherit",
                transition: "border-color 150ms cubic-bezier(0.23,1,0.32,1), box-shadow 150ms cubic-bezier(0.23,1,0.32,1)",
              }}
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            style={{
              width: "100%", padding: "13px 0", marginTop: 4,
              background: loading
                ? "#94a3b8"
                : "linear-gradient(135deg, #1E3A5F 0%, #3A3C7A 100%)",
              color: "#fff", border: "none", borderRadius: 10,
              fontSize: 14, fontWeight: 700,
              cursor: loading ? "not-allowed" : "pointer",
              boxShadow: loading ? "none" : "0 4px 16px rgba(30,58,95,0.35)",
              transition: "opacity 150ms cubic-bezier(0.23,1,0.32,1), transform 100ms cubic-bezier(0.23,1,0.32,1)",
              display: "flex", alignItems: "center", justifyContent: "center", gap: 8,
            }}
          >
            {loading ? (
              <>
                <div className="dots-loader" style={{ padding: 0 }}>
                  <span style={{ background: "rgba(255,255,255,0.7)", width: 6, height: 6 }} />
                  <span style={{ background: "rgba(255,255,255,0.7)", width: 6, height: 6 }} />
                  <span style={{ background: "rgba(255,255,255,0.7)", width: 6, height: 6 }} />
                </div>
                Ingresando...
              </>
            ) : "Ingresar al CRM →"}
          </button>
        </form>

        <p style={{ textAlign: "center", fontSize: 11, color: "#94a3b8", marginTop: 22, lineHeight: 1.5 }}>
          ¿Sin cuenta? Contacta al administrador del sistema.
        </p>
      </div>
    </div>
  );
}
